import Spinner from '@xo-union/tk-component-spinner';
import React from 'react';

import styles from './content.scss';

interface Props {
  children: any;
  className?: string;
  loading?: boolean;
}

export const Content: React.FC<Props> = ({ children, loading, className = '' }) => (
  <div className={`${styles.container} ${className}`}>
    {loading ? <Spinner className={styles.spinner} /> : children}
  </div>
);
